export const SEARCHABLE_COLUMNS = new Set([
  "risk_id",
  "risk",
  "category",
  "status",
  "owners",
  "classification",
]);

export const FIXED_COLUMNS = new Set(["risk_id"]);

export const HIDDEN_COLUMNS = new Set<string>([
  "category",
  "risk_score",
  "assessed_risk_score",
  "status",
  "signal_status",
  "signals",
  "owners",
  "longitudinal_trend_of_risk_score",
  "longitudinal_risk_status_trajectory",
  "mitigation_plan",
  "classification",
  "created_by",
  "band",
]);

export const RISK_COLUMN_ORDER = [
  "risk_id",
  "risk",
  "details",
  "probability",
  "impact",
  "detectability",
  "pid_score",
  "assessed_risk_score",
  "owners",
] as const;

export const TITLE_MAPPING = {
  risk_id: "Risk ID",
  risk: "Risk",
  category: "Category",
  details: "Details",
  probability: "Probability",
  impact: "Impact",
  detectability: "Detectability",
  pid_score: "PID Score",
  assessed_risk_score: "Assessed Risk Score",
  risk_score: "Risk Score",
  status: "Status",
  signals: "Signals",
  signal_status: "Signal Status",
  longitudinal_trend_of_risk_score: "Longitudinal Trend Of Risk Score",
  longitudinal_risk_status_trajectory: "Longitudinal Risk Status Trajectory",
  mitigation_plan: "Mitigation Plan",
  owners: "Owners",
  assignee: "Assignee",
  created_by: "Created By",
  classification: "Classification",
} satisfies Record<string, string>;

export const COLUMN_WIDTHS = {
  DEFAULT: 160,
  risk_id: 120,
  risk: 320,
  category: 160,
  status: 140,
  risk_score: 150,
  assessed_risk_score: 170,
  probability: 130,
  impact: 120,
  detectability: 140,
  pid_score: 120,
  signal_status: 220,
  signals: 260,
  owners: 220,
  classification: 180,
  mitigation_plan: 280,
  details: 420,
  created_by: 180,
  longitudinal_trend_of_risk_score: 320,
  longitudinal_risk_status_trajectory: 320,
} satisfies Record<string, number>;
